<template>
  <section :class="nationalityCheckClasses">
    <FlexWrap>
      <div class="container">
        <header class="title-wrapper">
          <transition name="title" mode="out-in">
            <p v-if="panel === 'begin'" class="title">Nog één keertje dan:<br>
              <span class="large">{{ title }}</span></p>
            <h2 v-if="panel === 'success'">
              Oké, dan staat echt niks meer jouw tripje naar de stembus in de weg.
            </h2>
            <h2 v-if="panel === 'fail'">
              {{ failText }}
            </h2>
          </transition>
        </header>
        <figure class="figure">
          <img
            :src="src"
            draggable="false"
            alt=""
            class="character"
            width="50"
            height="165"
            :class="characterClasses"
          />
        </figure>
        <footer class="footer">
          <CheckPanel v-if="panel === 'begin'">
            <template slot="buttons">
              <CheckPanelButton correct @click.native="vote(true)">
                Ja
              </CheckPanelButton>
              <CheckPanelButton @click.native="vote(false)">
                Nee
              </CheckPanelButton>
            </template>
          </CheckPanel>
          <ScrollChevron
            scrollTo=".chapter-4-panel-2"
            :conditionals="panel !== 'begin'"
          />
        </footer>
      </div>
    </FlexWrap>
  </section>
</template>

<script>
import { EventBus } from '@/EventBus'
import { CheckPanel, CheckPanelButton } from '@/components/check-panel'
import { ScrollChevron, FlexWrap } from '@/components/chapter'
import { trekInteractive } from '@/utils/trek'

export default {
  name: 'NationalityCheck',
  data () {
    return {
      filename: 'fy',
      panel: 'begin',
      failText: 'Helaas, je bent nog te jong. De kiesgerechtigde leeftijd was nog steeds 25 jaar.'
    }
  },
  mounted () {
    EventBus.$on('characterChoice', filename => {
      this.filename = filename
    })
  },
  methods: {
    vote (isDutchAndOldEnough) {
      trekInteractive('1919-heeft-nederlandse-nationaliteit')
      EventBus.$emit('isDutchAndOldEnough', isDutchAndOldEnough)
      if (['fy', 'my'].includes(this.filename)) {
        this.panel = 'fail'
        this.failText = isDutchAndOldEnough ? 'Helaas, je bent nog te jong. De kiesgerechtigde leeftijd was nog steeds 25 jaar.' : 'Helaas, zonder de Nederlandse nationaliteit ben je niet kiesgerechtigd.'
      }

      if (['fo', 'mo'].includes(this.filename)) {
        this.panel = isDutchAndOldEnough ? 'success' : 'fail'
        this.failText = 'Helaas, je bent nog te jong of je hebt geen Nederlandse nationaliteit. De kiesgerechtigde leeftijd was nog steeds 25 jaar en zonder de Nederlandse nationaliteit ben je niet kiesgerechtigd.'
      }
    }
  },
  computed: {
    nationalityCheckClasses () {
      return {
        'nationality-check': true,
        'fail-nationality-check': this.panel === 'fail'
      }
    },
    src () {
      return require(`@/assets/images/char-${this.filename}.svg`)
    },
    characterClasses () {
      return {
        'character': true,
        'small': this.panel === 'begin'
      }
    },
    title () {
      return ['fo', 'mo'].includes(this.filename) ? 'Heb je de Nederlandse nationaliteit? En ben je ouder dan 25?' : 'Heb je de Nederlandse nationaliteit?'
    }
  },
  components: {
    CheckPanel,
    CheckPanelButton,
    ScrollChevron,
    FlexWrap
  }
}
</script>

<style lang="scss" scoped>
.nationality-check {
  background-color: $c-blue;
  color: white;
  transition: background-color 1s ease;
}

.fail-nationality-check {
  background-color: $c-red;
}

.title-enter-active,
.title-leave-active {
  transition: all 1600ms cubic-bezier(0.19, 1, 0.22, 1);
  transition-property: opacity, transform;
  will-change: opacity, transform;
}

.title-leave-active {
  transition-duration: 400ms;
}

.title-enter,
.title-leave-to {
  opacity: 0;
}

.title-enter {
  transform: translateY(-25px);
}

.title-leave-to {
  transform: translateY(25px);
}

.title-wrapper {
  height: 135px;
  text-align: center;
}

.large {
  font-size: 26px;
  font-weight: $fw-bold;
  text-align: center;
}

.figure {
  text-align: center;
  padding: 2em 0;
}

.character {
  transition: transform 2500ms cubic-bezier(0.19, 1, 0.22, 1);
  transform: scale(1);
  will-change: transform;
  transform-origin: 50% 0;
}

.footer {
  height: 100px;
  position: relative;
  text-align: center;
}
</style>
